
define( 'FORCES_AND_MOTION_BASICS/../nls/iw/forces-and-motion-basics-strings',{
          "none": "כלום",
          "force": "כח",
          "values": "ערכים",
          "frictionTitle": "חיכוך",
          "redWins": "האדום ניצח!",
          "frictionForce": "כח החיכוך",
          "pause": "השהה",
          "friction": "חיכוך",
          "accelerationLab": "מעבדת תאוצה",
          "forces-and-motion-basics.name": "כוחות ותנועה: הבסיס",
          "appliedForce": "הכח המופעל",
          "leftForce": "כח שמאלי",
          "rightForce": "כח ימני",
          "acceleration": "תאוצה",
          "sound": "קול",
          "lots": "הרבה",
          "forces": "כוחות",
          "motion": "תנועה",
          "tugOfWar": "משיכת חבל",
          "go": "משוך!",
          "newtons.n": "ניוטון (N)",
          "sumOfForcesEqualsZero": "סכום הכוחות = 0",
          "blueWins": "הכחול ניצח!",
          "speed": "מהירות",
          "sumOfForces": "סכום הכוחות",
          "return": "חזור",
          "translation.credits": "AdM",
          "newtons": "ניוטון",
          "masses": "מסות"
        } );